const groupPrefix = 'orders'

export const apiOrders = {
	createReservation: async (productID: number, days: number) => {
		const { data } = await apiCommon<IOrder>(`${groupPrefix}`, {
			method: 'POST',
			body: orderToJSON({ productID, days }),
		})
		return Order(data)
	},

	fetchOrders: async () => {
		const { data } = await apiCommon<IOrder[]>(`${groupPrefix}`, {
			method: 'GET',
		})
		return data.map((order) => Order(order))
	},

	fetchOrder: async (orderID: string) => {
		const { data } = await apiCommon<IOrder>(`${groupPrefix}/${orderID}`, {
			method: 'GET',
		})
		return Order(data)
	},
}
